import { Routes } from '@angular/router';
import { AuthComponent } from './auth/pages/auth/auth.component';
import { AuthGuard } from './auth-guard.service';
import { HomeComponent } from './home/pages/home/home.component';
import { MasterHomeComponent } from './master/pages/master-home/master-home.component';
import { UsuarioAdminListaComponent } from './master/pages/usuario-admin-lista/usuario-admin-lista.component';
import { UsuarioAdminCadastroComponent } from './master/pages/usuario-admin-cadastro/usuario-admin-cadastro.component';
import { PerfilListaComponent } from './master/pages/perfil-lista/perfil-lista.component';
import { PerfilCadastroComponent } from './master/pages/perfil-cadastro/perfil-cadastro.component';
import { VisualizarLogDetalheComponent } from './desenvolvedor/pages/visualizar-log-detalhe/visualizar-log-detalhe.component';
import { VisualizarLogListaComponent } from './desenvolvedor/pages/visualizar-log-lista/visualizar-log-lista.component';
import { DesenvolvedorHomeComponent } from './desenvolvedor/pages/desenvolvedor-home/desenvolvedor-home.component';
import { CategoriaArquivoListaComponent } from './desenvolvedor/pages/categoria-arquivo-lista/categoria-arquivo-lista.component';
import { CategoriaArquivoCadastroComponent } from './desenvolvedor/pages/categoria-arquivo-cadastro/categoria-arquivo-cadastro.component';
import { ArquivoListaComponent } from './desenvolvedor/pages/arquivo-lista/arquivo-lista.component';
import { CadastroArquivoComponent } from './desenvolvedor/pages/arquivo-cadastro/arquivo-cadastro.component';
import { TabelaIbptComponent } from './desenvolvedor/pages/tabela-ibpt/tabela-ibpt.component';
import { InteligenciaDadosHomeComponent } from './inteligencia-dados/pages/inteligencia-dados-home/inteligencia-dados-home.component';
import { ConfigurarRelatorioComponent } from './inteligencia-dados/pages/configurar-relatorio/configurar-relatorio.component';
import { ConfigurarRelatorioCadastroComponent } from './inteligencia-dados/pages/configurar-relatorio-cadastro/configurar-relatorio-cadastro.component';
import { MeusRelatoriosComponent } from './inteligencia-dados/pages/meus-relatorios/meus-relatorios.component';
import { TintasHomeComponent } from './tintas/pages/tintas-home/tintas-home.component';
import { FabricanteListaComponent } from './tintas/pages/fabricante-lista/fabricante-lista.component';
import { FabricanteCadastroComponent } from './tintas/pages/fabricante-cadastro/fabricante-cadastro.component';
import { SuporteHomeComponent } from './suporte/pages/suporte-home/suporte-home.component';
import { SuperAcessoCadastroComponent } from './suporte/pages/super-acesso-cadastro/super-acesso-cadastro.component';
import { SuperAcessoListaComponent } from './suporte/pages/super-acesso-lista/super-acesso-lista.component';
import { ModuloEnum } from './shared/enums/modulo.enum';
import { PermissaoEnum } from './shared/enums/permissao.enum';
import { all } from './shared/helpers/permissoes.helper';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ImplantacaoHomeComponent } from './implantacao/pages/implantacao-home/implantacao-home.component';
import { EmpresaListaComponent } from './implantacao/pages/empresa-lista/empresa-lista.component';
import { EmpresaCadastroComponent } from './implantacao/pages/empresa-cadastro/empresa-cadastro.component';
import { EmpresaGrupoCadastroComponent } from './implantacao/pages/empresa-grupo-cadastro/empresa-grupo-cadastro.component';
import { EmpresaGrupoListaComponent } from './implantacao/pages/empresa-grupo-lista/empresa-grupo-lista.component';
import { NotificacaoListaComponent } from './suporte/pages/notificacao-lista/notificacao-lista.component';
import { EnviarNotificacaoComponent } from './suporte/pages/enviar-notificacao/enviar-notificacao.component';

// prettier-ignore
export const routes: Routes = [
    { path: '', component: AuthComponent, pathMatch: 'full' },
    { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
    { path: 'master',
        children: [
            { path: '', component: MasterHomeComponent, canActivate: [AuthGuard], data: { 
                modulo: ModuloEnum.Master, permissoes: []
            }},
        
            { path: 'usuario', component: UsuarioAdminListaComponent, canActivate: [AuthGuard], data: {
                modulo: ModuloEnum.Master, permissoes: all("Master_Usuario")
            }},
        
            { path: 'usuario/cadastrar', component: UsuarioAdminCadastroComponent, canActivate: [AuthGuard], data: { 
                modulo: ModuloEnum.Master, permissoes: [
                    PermissaoEnum.Master_Usuario_Incluir,
                    PermissaoEnum.Master_Usuario_Alterar
                ]
            }},
        
            { path: 'perfil', component: PerfilListaComponent, canActivate: [AuthGuard], data: { 
                modulo: ModuloEnum.Master, permissoes: all("Master_usuario")
            }},
        
            { path: 'perfil/cadastrar', component: PerfilCadastroComponent, canActivate: [AuthGuard], data: { 
                modulo: ModuloEnum.Master, permissoes: [
                    PermissaoEnum.Master_Perfil_Incluir,
                    PermissaoEnum.Master_Perfil_Alterar
                ]
            }},
        ]
    },
    { path: 'desenvolvedor', 
        children: [
            { path: '', component: DesenvolvedorHomeComponent, canActivate: [AuthGuard], data: { 
                modulo: ModuloEnum.Desenvolvedor, permissoes: []
            }},
        
            { path: 'logs', component: VisualizarLogListaComponent, canActivate: [AuthGuard], data: { 
                modulo: ModuloEnum.Desenvolvedor, permissoes: [ PermissaoEnum.Desenvolvedor_Logs_Listar ]
            }},
        
            { path: 'logs/detalhe', component: VisualizarLogDetalheComponent, canActivate: [AuthGuard], data: { 
                modulo: ModuloEnum.Desenvolvedor, permissoes: [ PermissaoEnum.Desenvolvedor_Logs_Listar ]
            }},
        
            { path: 'categoria-arquivo', component: CategoriaArquivoListaComponent, canActivate: [AuthGuard], data: { 
                modulo: ModuloEnum.Desenvolvedor, permissoes: all("Desenvolvedor_CategoriaArquivo")
            }},
        
            { path: 'categoria-arquivo/cadastrar', component: CategoriaArquivoCadastroComponent, canActivate: [AuthGuard], data: { 
                modulo: ModuloEnum.Desenvolvedor, permissoes: [
                    PermissaoEnum.Desenvolvedor_CategoriaArquivo_Incluir,
                    PermissaoEnum.Desenvolvedor_CategoriaArquivo_Alterar
                ]
            }},
        
            { path: 'arquivo', component: ArquivoListaComponent, canActivate: [AuthGuard], data: { 
                modulo: ModuloEnum.Desenvolvedor, permissoes: all("Desenvolvedor_Arquivo")
            }},
        
            { path: 'arquivo/cadastrar', component: CadastroArquivoComponent, canActivate: [AuthGuard], data: {
                modulo: ModuloEnum.Desenvolvedor, permissoes: [ PermissaoEnum.Desenvolvedor_Arquivo_Incluir ]
            }},

            { path: 'tabela-ibpt', component: TabelaIbptComponent, canActivate: [AuthGuard], data: {
                modulo: ModuloEnum.Desenvolvedor, permissoes: [ PermissaoEnum.Desenvolvedor_TabelaIbpt_Listar ]
            }},
        ]
    }, 
    { path: 'inteligencia-dados', 
        children: [
            { path: '', component: InteligenciaDadosHomeComponent, canActivate: [AuthGuard], data: { 
                modulo: ModuloEnum.InteligenciaDados, permissoes: []
            }},
        
            { path: 'meus-relatorios', component: MeusRelatoriosComponent, canActivate: [AuthGuard], data: { 
                modulo: ModuloEnum.InteligenciaDados, permissoes: [ PermissaoEnum.InteligenciaDados_MeusRelatorios_Listar ]
            }},
        
            { path: 'configurar-relatorio', component: ConfigurarRelatorioComponent, canActivate: [AuthGuard], data: { 
                modulo: ModuloEnum.InteligenciaDados, permissoes: all("InteligenciaDados_ConfigurarRelatorio")
            }},
        
            { path: 'configurar-relatorio/cadastrar', component: ConfigurarRelatorioCadastroComponent, canActivate: [AuthGuard], data: { 
                modulo: ModuloEnum.InteligenciaDados, permissoes: [
                    PermissaoEnum.InteligenciaDados_ConfigurarRelatorio_Incluir,
                    PermissaoEnum.InteligenciaDados_ConfigurarRelatorio_Alterar
                ]
            }},
        ]
    },
    { path: 'tintas', 
        children: [
            { path: '', component: TintasHomeComponent, canActivate: [AuthGuard], data: { 
                modulo: ModuloEnum.Tintas, permissoes: []
            }},
        
            { path: 'fabricante', component: FabricanteListaComponent, canActivate: [AuthGuard], data: { 
                modulo: ModuloEnum.Tintas, permissoes: all("RepositorioTintas_Fabricante")
            }},
        
            { path: 'fabricante/cadastrar', component: FabricanteCadastroComponent, canActivate: [AuthGuard], data: { 
                modulo: ModuloEnum.Tintas, permissoes: [ PermissaoEnum.RepositorioTintas_Fabricante_Alterar ]
            }},
        ]
    },
    { path: 'suporte', 
        children: [
            { path: '', component: SuporteHomeComponent, canActivate: [AuthGuard], data: { 
                modulo: ModuloEnum.Suporte, permissoes: []
            }},
        
            { path: 'super-acesso', component: SuperAcessoListaComponent, canActivate: [AuthGuard], data: { 
                modulo: ModuloEnum.Suporte, permissoes: all("Suporte_SuperAcesso")
            }},
        
            { path: 'super-acesso/cadastrar', component: SuperAcessoCadastroComponent, canActivate: [AuthGuard], data: { 
                modulo: ModuloEnum.Suporte, permissoes: [ PermissaoEnum.Suporte_SuperAcesso_Incluir ]
            }},
            
            { path: 'notificacao', component: NotificacaoListaComponent, canActivate: [AuthGuard], data: { 
                modulo: ModuloEnum.Suporte, permissoes: [PermissaoEnum.Suporte_Notificacao_Visualizar]
            }},

            { path: 'notificacao/enviar', component: EnviarNotificacaoComponent, canActivate: [AuthGuard], data: { 
                modulo: ModuloEnum.Suporte, permissoes: [PermissaoEnum.Suporte_Notificacao_Inserir]
            }},
        ]
    },
    { path: 'implantacao',
        children: [
            { path: '', component: ImplantacaoHomeComponent, canActivate: [AuthGuard], data: {
                modulo: ModuloEnum.Implantacao, permissoes: []
            }},

            { path: 'empresa', component: EmpresaListaComponent, canActivate: [AuthGuard], data: {
                modulo: ModuloEnum.Implantacao, permissoes: all("Implantacao_Empresa")
            }},

            { path: 'empresa/cadastrar', component: EmpresaCadastroComponent, canActivate: [AuthGuard], data: {
                modulo: ModuloEnum.Implantacao, permissoes: [ PermissaoEnum.Implantacao_Empresa_Alterar, PermissaoEnum.Implantacao_Empresa_Incluir ]
            }},

            { path: 'empresa-grupo', component: EmpresaGrupoListaComponent, canActivate: [AuthGuard], data: {
                modulo: ModuloEnum.Implantacao, permissoes: all("Implantacao_GrupoEmpresa")
            }},

            { path: 'empresa-grupo/cadastrar', component: EmpresaGrupoCadastroComponent, canActivate: [AuthGuard], data: {
                modulo: ModuloEnum.Implantacao, permissoes: [ PermissaoEnum.Implantacao_GrupoEmpresa_Incluir, PermissaoEnum.Implantacao_GrupoEmpresa_Alterar ]
            }}
        ]
    },
    { path: '**', component: PageNotFoundComponent },
];
